/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusFuelOption } from './BonusFuelOption';
import {
    BonusFuelOptionFromJSON,
    BonusFuelOptionFromJSONTyped,
    BonusFuelOptionToJSON,
    BonusFuelOptionToJSONTyped,
} from './BonusFuelOption';
import type { SiteConfigurationKey } from './SiteConfigurationKey';
import {
    SiteConfigurationKeyFromJSON,
    SiteConfigurationKeyFromJSONTyped,
    SiteConfigurationKeyToJSON,
    SiteConfigurationKeyToJSONTyped,
} from './SiteConfigurationKey';
import type { PhoneNumberBody } from './PhoneNumberBody';
import {
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
    PhoneNumberBodyToJSONTyped,
} from './PhoneNumberBody';
import type { PaymentMethods } from './PaymentMethods';
import {
    PaymentMethodsFromJSON,
    PaymentMethodsFromJSONTyped,
    PaymentMethodsToJSON,
    PaymentMethodsToJSONTyped,
} from './PaymentMethods';

/**
 * 
 * @export
 * @interface SiteConfigurationBody
 */
export interface SiteConfigurationBody {
    /**
     * 
     * @type {SiteConfigurationKey}
     * @memberof SiteConfigurationBody
     */
    configKey: SiteConfigurationKey;
    /**
     * 
     * @type {string}
     * @memberof SiteConfigurationBody
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConfigurationBody
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConfigurationBody
     */
    buttonText?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConfigurationBody
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConfigurationBody
     */
    description?: string;
    /**
     * 
     * @type {object}
     * @memberof SiteConfigurationBody
     */
    data?: object;
    /**
     * 
     * @type {string}
     * @memberof SiteConfigurationBody
     */
    value?: string;
    /**
     * 
     * @type {number}
     * @memberof SiteConfigurationBody
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteConfigurationBody
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SiteConfigurationBody
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof SiteConfigurationBody
     */
    business?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SiteConfigurationBody
     */
    nftGroupings?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof SiteConfigurationBody
     */
    startDate?: number;
    /**
     * 
     * @type {number}
     * @memberof SiteConfigurationBody
     */
    endDate?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SiteConfigurationBody
     */
    isActive?: boolean;
    /**
     * 
     * @type {BonusFuelOption}
     * @memberof SiteConfigurationBody
     */
    bonusFuelType?: BonusFuelOption;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof SiteConfigurationBody
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {Array<PaymentMethods>}
     * @memberof SiteConfigurationBody
     */
    paymentMethods?: Array<PaymentMethods>;
}



/**
 * Check if a given object implements the SiteConfigurationBody interface.
 */
export function instanceOfSiteConfigurationBody(value: object): value is SiteConfigurationBody {
    if (!('configKey' in value) || value['configKey'] === undefined) return false;
    return true;
}

export function SiteConfigurationBodyFromJSON(json: any): SiteConfigurationBody {
    return SiteConfigurationBodyFromJSONTyped(json, false);
}

export function SiteConfigurationBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteConfigurationBody {
    if (json == null) {
        return json;
    }
    return {
        
        'configKey': SiteConfigurationKeyFromJSON(json['configKey']),
        'asset': json['asset'] == null ? undefined : json['asset'],
        'url': json['url'] == null ? undefined : json['url'],
        'buttonText': json['buttonText'] == null ? undefined : json['buttonText'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'data': json['data'] == null ? undefined : json['data'],
        'value': json['value'] == null ? undefined : json['value'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'user': json['user'] == null ? undefined : json['user'],
        'business': json['business'] == null ? undefined : json['business'],
        'nftGroupings': json['nftGroupings'] == null ? undefined : json['nftGroupings'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'bonusFuelType': json['bonusFuelType'] == null ? undefined : BonusFuelOptionFromJSON(json['bonusFuelType']),
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'paymentMethods': json['paymentMethods'] == null ? undefined : ((json['paymentMethods'] as Array<any>).map(PaymentMethodsFromJSON)),
    };
}

export function SiteConfigurationBodyToJSON(json: any): SiteConfigurationBody {
    return SiteConfigurationBodyToJSONTyped(json, false);
}

export function SiteConfigurationBodyToJSONTyped(value?: SiteConfigurationBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configKey': SiteConfigurationKeyToJSON(value['configKey']),
        'asset': value['asset'],
        'url': value['url'],
        'buttonText': value['buttonText'],
        'title': value['title'],
        'description': value['description'],
        'data': value['data'],
        'value': value['value'],
        'percentage': value['percentage'],
        'amount': value['amount'],
        'user': value['user'],
        'business': value['business'],
        'nftGroupings': value['nftGroupings'],
        'startDate': value['startDate'],
        'endDate': value['endDate'],
        'isActive': value['isActive'],
        'bonusFuelType': BonusFuelOptionToJSON(value['bonusFuelType']),
        'phoneNumber': PhoneNumberBodyToJSON(value['phoneNumber']),
        'paymentMethods': value['paymentMethods'] == null ? undefined : ((value['paymentMethods'] as Array<any>).map(PaymentMethodsToJSON)),
    };
}

